import React from "react";

import { Button } from "@braintrust/braintrust-ui-components";
import {
  CloseIcon,
  LongArrowLeftIcon,
} from "@braintrust/braintrust-ui-components/Icons";
import { RouterLink } from "@js/components/link";

export type HeaderButtonProps = {
  backLink: string;
  isEdit?: boolean;
  onClick?: () => void;
};

export const HeaderButton = ({
  isEdit,
  backLink,
  onClick,
}: HeaderButtonProps) => {
  const config = isEdit
    ? {
        startIcon: <CloseIcon />,
        label: "Exit without saving",
      }
    : {
        startIcon: <LongArrowLeftIcon />,
        label: "Back",
      };

  return (
    <Button
      variant="transparent"
      shape="squared"
      to={backLink}
      sx={{ marginRight: 3 }}
      startIcon={config.startIcon}
      RouterLink={RouterLink}
      onClick={onClick}
    >
      {config.label}
    </Button>
  );
};
